import { __rest } from 'tslib';
import React__default from 'react';
import { SvgIcon24 } from '../svgIcon24.js';

const List = (_a) => {
    var { fill = '#929292' } = _a, others = __rest(_a, ["fill"]);
    return (React__default.createElement(SvgIcon24, Object.assign({ viewbox: "0 0 25 24", title: "List" }, others),
        React__default.createElement("g", { id: "ICON" },
            React__default.createElement("path", { d: "M8.10925 20.5166H23.0677V18.5166H8.10925V20.5166ZM2.02051 21.0166H5.02051V18.0166H2.02051V21.0166ZM8.10925 13H23.0677V11H8.10925V13ZM2.02051 13.5H5.02051V10.5H2.02051V13.5ZM8.10925 5.4834H23.0677V3.4834H8.10925V5.4834ZM2.02051 5.9834H5.02051V2.9834H2.02051V5.9834Z", fill: fill }))));
};

export { List as default };
